import { render, staticRenderFns } from "./PlansTable.vue?vue&type=template&id=46923e70&scoped=true&"
import script from "./PlansTable.vue?vue&type=script&lang=js&"
export * from "./PlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46923e70",
  null
  
)

export default component.exports